import { render, staticRenderFns } from "./viewProblem.vue?vue&type=template&id=0890e5f5&scoped=true"
import script from "./viewProblem.vue?vue&type=script&lang=js"
export * from "./viewProblem.vue?vue&type=script&lang=js"
import style0 from "./viewProblem.vue?vue&type=style&index=0&id=0890e5f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890e5f5",
  null
  
)

export default component.exports